import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BaseInitialState, StateStatus } from '../extension-store/interfaces/extension-store.interfaces';

export interface VersionUpdate extends BaseInitialState {
  updateNeeded: boolean;
  updateVersion: string;
}

const initialState: VersionUpdate = {
  error: null,
  status: StateStatus.IDLE,
  updateNeeded: false,
  updateVersion: '',
};

export const VersionUpdateState = createSlice({
  name: 'VersionUpdateReducer',
  initialState,
  reducers: {
    setUpdateNeeded: (mutableState, action: PayloadAction<boolean>) => {
      mutableState.updateNeeded = action.payload;
      mutableState.status = StateStatus.SUCCESS;
    },
    setUpdateVersion: (mutableState, action: PayloadAction<string>) => {
      mutableState.updateVersion = action.payload;
    },
  },
});

export const { setUpdateNeeded, setUpdateVersion } = VersionUpdateState.actions;
